<template>
  <v-list class="py-0" v-if="['super_admin', 'teacher', 'accountant','education_manager'].includes(role.type)">
    <Report />
  </v-list>
</template>
<script>
import Report from '@/components/basic/menu/Report.vue'
import { mapState } from 'vuex'
export default {
  components: {
    Report
  },
  computed: {
    ...mapState('auth', ['profile', 'role'])
  }
}
</script>
